var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workbench"},[_c('img',{staticClass:"workbench_img",attrs:{"src":require("../../assets/img/home/homepage.png"),"alt":""}})])
}]

export { render, staticRenderFns }